<!--
  --
  -- 支払方法アイテムコンポーネント
  --
  -->
<template>
  <v-list-item
    :value="pay.payID"
  >

    <!-- 選択状態 -->
    <v-list-item-icon class="my-5">
      <v-icon v-text="active ? 'radio_button_checked': 'radio_button_unchecked'"/>
    </v-list-item-icon>

    <!-- カード支払 -->
    <c-content-card
      v-if="pay.type === PAYTYPE_CARD"
      :pay="pay"
    />

    <!-- 現地支払 -->
    <c-content-spot
      v-else
      :pay="pay"
    />

  </v-list-item>
</template>

<script>
import CContentCard from './CContentCard'
import CContentSpot from './CContentSpot'

import * as C from '@/consts'

export default {
  name: 'CPaymentItem',
  components: {
    CContentCard,
    CContentSpot
  },

  props: {
    pay: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    PAYTYPE_SPOT: C.PAYTYPE_SPOT,
    PAYTYPE_CARD: C.PAYTYPE_CARD
  })
}
</script>
